import Widget from "../Components/Widgets"
import MainHeader from "../Layouts/MainHeader"
import pattern1 from "../assets/images/pattern1.png"
import pattern2 from "../assets/images/pattern2.png"
import pattern3 from "../assets/images/pattern3.png"
import pattern4 from "../assets/images/pattern4.png"
import pattern5 from "../assets/images/pattern5.png"
import pattern6 from "../assets/images/pattern6.png"
import pattern7 from "../assets/images/pattern7.png"
import pattern8 from "../assets/images/pattern8.png"
import Log from "../Components/log"
import { useGetDashboardQuery } from "../Redux/Apis/panelApi"
import Loading from "../Layouts/Loading"
import Error from "../Layouts/Error"
import { Link } from "react-router-dom"
import { fa_currency, fa_number } from "../utils/Persian"
import CircularProgressBar from "../utils/CircularProgressBar"

export default function Main() {
    document.title = "داشبورد";
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetDashboardQuery({})

    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess) {
        return (
        <>
        <MainHeader data={data.user}/>
        <div className="row">
            {data.user.level === -1 && data.user.invoice > 0 && <div className="alert alert-secondary d-flex align-items-center" role="alert">
                <i className="zmdi zmdi-alert-triangle"></i>
                <div className="ms-2">
                     شما درخواست طراحی قالب اختصاصی برای سایت خود داده ایید، لطفا جهت شروع فرایند طراحی فاکتور سفارش خود را پرداخت نمایید.
                     <Link to="/invoice" className="alert-link ms-1">پرداخت فاکتور</Link>
                </div>
            </div>} 

            {data.user.level === -1 && <div className="alert alert-secondary d-flex align-items-center" role="alert">
                <i className="zmdi zmdi-alert-triangle"></i>
                <div className="ms-2">
                قالب اختصاصی شما پس از طی مراحل طراحی و پیاده سازی از همین پنل قابل دسترس خواهد بود. مراحل فرایند طراحی از طریق پیامک به اطلاع شما خواهد رسید.
                </div>
            </div>}

            {data.user.level !== -1 && data.user.invoice > 0 && <div className="alert alert-danger d-flex align-items-center" role="alert">
                <i className="zmdi zmdi-alert-triangle"></i>
                <div className="ms-2">
                    شما صورتحساب پرداخت نشده دارید. لطفا قبل از منقضی شدن دامنه و پکیج فعلی خود نسبت به پرداخت صورتحساب خود اقدام فرمایید.
                     <Link to="/invoice" className="alert-link ms-1">پرداخت صورتحساب</Link>
                </div>
            </div>}

            {data.user.level === 0 && <div className="alert alert-secondary d-flex align-items-center" role="alert">
                <i className="zmdi zmdi-alert-triangle"></i>
                <div className="ms-2">
                     دامنه شما هنوز به پنل لینکت متصل نگردیده است، لطفا از بخش مدیریت دامنه وضعیت دامنه خود را بررسی نمایید. 
                     <Link to="/domain" className="alert-link ms-1">مدیریت دامنه</Link>
                </div>
            </div>}

            {data.user.level === 1 && <div className="alert alert-success d-flex align-items-center" role="alert">
                <i className="zmdi zmdi-badge-check"></i>
                <div className="ms-2">
                در حال حاضر سایت شما روی سابدامنه لینکت در دسترس می باشد.                  
                     <a href={data.user.sub_domain} target="_blank" rel="noreferrer" className="alert-link ms-1">{data.user.sub_domain}</a>
                </div>
            </div>}


            <div className="col-md-8 col-sm-12 mb-2">
                <div className="row row-cols-1 row-cols-md-2 g-4">
                    <Widget name="تنظیمات قالب سایت" image={pattern1} items={[`نوع قالب: ${data.user.theme}`,`تعداد صفحات: ${fa_number(data.user.pages)}`]} link={{name: "ویرایش قالب",url: "/edit-pages"}} status={data.user.level >= 1}/>
                    
                    <Widget name="وبلاگ" image={pattern2} items={[`تعداد پست ها: ${fa_number(data.user.blogs)}`,`تعداد دسته بندی ها: ${fa_number(data.user.blogCat)}`]} link={{name: "مشاهده",url: "/blog"}} status={data.user.level >= -1}/>
                    
                    <Widget name="اطلاعات تماس سایت" image={pattern3} items={[`شماره ثابت: ${data.user.phone !== '-' ? fa_number(data.user.phone) : '-'}`,`شماره همراه: ${data.user.mobile !== '-' ? fa_number(data.user.mobile) : "-"}`]} link={{name: "مشاهده/ویرایش",url: "/contact"}} status={data.user.level >= -1}/>
                    
                    <Widget name="پیام های کاربران" image={pattern4} items={[`پیام خوانده نشده: ${fa_number(data.user.messeages)}`]} link={{name: "مشاهده",url: "/message"}} status={data.user.level >= -1}/>
                    
                    <Widget name="تنظیمات فروشگاه" image={pattern5} items={[`وضعیت فروشگاه : ${data.shop.status ? "فعال" : 'غیر فعال'}`,`درگاه پرداخت : ${data.shop.gateway > 0 ? fa_number(data.shop.gateway) + " درگاه فعال" : "غیر فعال"}`]} link={{name: "ویرایش فروشگاه",url: "/shop"}} status={data.user.level > 2}/>
                    
                    <Widget name="مشتریان" image={pattern6} items={[`مشتریان امروز : ${fa_number(data.shop.today_clients)}`,`مشتریان کل : ${fa_number(data.shop.clients)}`]} link={{name: "مشاهده مشتریان",url: "/client"}} status={data.user.level > 2}/>
                    
                    <Widget name="فاکتور ها" image={pattern6} items={[`فاکتورهای امروز : ${fa_currency(data.shop.today_factor)}`,`مجموع فاکتورها : ${fa_currency(data.shop.factor)}`]} link={{name: "مشاهده فاکتور ها",url: "/factor"}} status={data.user.level > 2}/>
                    
                    <Widget name="محصولات" image={pattern7} items={[`تعداد محصولات : ${fa_number(data.shop.products)}`,`تعداد دسته ها : ${fa_number(data.shop.category)}`]} link={{name: "ویرایش محصولات",url: "/product"}} status={data.user.level > 2}/>
                    
                    {data.user.modules && data.user.modules.includes("tournament") && <Widget name="مسابقات" image={pattern8} items={[`مسابقات فعال : ${fa_number(data.active_tours)}`,`کلیه مسابقات : ${fa_number(data.all_tours)}`]} link={{name: "مشاهده مسابقات",url: "/ebro-tours"}} status={data.user.level > 2}/>}
                </div>
            </div>

            <div className="col-md-4 col-sm-12 bg-light border rounded-3 ms-auto mb-2">
                <div className="row">
                    <div className="card rounded-0 rounded-top">
                        <div className="card-body px-0">
                            <h5 className="mb-0">
                                <i className="zmdi zmdi-accounts-list-alt ms-0 me-2"></i>
                                ناحیه کاربری
                            </h5>
                        </div>
                    </div>
                    <div className="col-12 rounded-0 bg-white py-2">
                        <div className="row text-center mt-2">
                            <div className="col">
                                <CircularProgressBar 
                                    selectedValue={data.user.mediaUsed}
                                    maxValue={data.user.media}
                                    label="تصویر"
                                />
                            </div>
                            <div className="col">
                                <CircularProgressBar
                                    selectedValue={data.user.expire}
                                    label="روز"
                                    maxValue={365}
                                    activeStrokeColor='#0f4fff'
                                    withGradient
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 mb-4 rounded-0 bg-white py-2">
                        <Link className="btn btn-outline-dark position-relative btn-circle rounded-5 m-2" type="button" to="/invoice">
                            <i className="zmdi zmdi-receipt zmdi-hc-lg"></i> صورتحساب ها
                            {data.user.invoice > 0 && <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                {fa_number(data.user.invoice)}
                                <span className="visually-hidden">Unpaid Invoices</span>
                            </span>}
                        </Link>
                        <Link className="btn btn-outline-dark btn-circle rounded-5 m-2" type="button" to="/domain">
                            <i className="zmdi zmdi-globe-lock zmdi-hc-lg"></i> مدیریت دامنه
                        </Link>
                        <Link className="btn btn-outline-dark btn-circle rounded-5 m-2" type="button" to="/package">
                            <i className="zmdi zmdi-shopping-cart-plus zmdi-hc-lg"></i> خرید پکیج
                        </Link>
                    </div>

                    <div className="card rounded-0 rounded-top">
                        <div className="card-body px-0">
                            <h5 className="mb-0">
                                <i className="zmdi zmdi-notifications me-2"></i>
                                اعلان ها
                                :
                                {data.logs && <span className="badge bg-warning text-dark float-end">{fa_number(data.logs.log.length)}</span>}
                            </h5>
                        </div>
                    </div>
                    {data.logs && <Log data={data.logs.log} />}
                </div>
            </div>
        </div>
        </>
    )}

    else return <></>
}